import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Hoeveel gegevens zijn er op dit moment onderweg? Zo kan een lege lijst het verschil
// maken tussen "nog aan het ophalen" en "er is echt niets".
let pending = 0;
const watchers = new Set();
const notify = () => watchers.forEach((cb) => cb(pending));

export const pendingRequests = () => pending;
export function onPendingChange(cb) {
  watchers.add(cb);
  return () => watchers.delete(cb);
}

// Elke geslaagde schrijfactie (POST/PUT/PATCH/DELETE) meldt zich hier, zodat
// afgeleide cijfers (zoals de totale bezetting) zichzelf meteen kunnen verversen.
const mutationWatchers = new Set();
export function onMutation(cb) {
  mutationWatchers.add(cb);
  return () => mutationWatchers.delete(cb);
}
const notifyMutation = () => mutationWatchers.forEach((cb) => cb());

api.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() === "get") {
    config._counted = true;
    pending += 1;
    notify();
  }
  return config;
});

const settle = (config) => {
  if (config?._counted) {
    config._counted = false;
    pending = Math.max(0, pending - 1);
    notify();
  }
};

// De sessie zit in een httpOnly cookie en wordt door de browser meegestuurd.
// We houden geen token bij in localStorage: dat is leesbaar voor XSS.
api.interceptors.response.use(
  (r) => {
    settle(r.config);
    if (!["get", "head", "options"].includes((r.config?.method || "get").toLowerCase())) notifyMutation();
    return r;
  },
  (e) => {
    settle(e.config);
    if (e.response?.status === 403 && e.response?.data?.detail?.code === "password_change_required" && window.location.pathname !== "/wachtwoord") {
      window.location.href = "/wachtwoord";
    }
    if (e.response?.status === 401) {
      localStorage.removeItem("cb_session");
      if (!window.location.pathname.includes("login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(e);
  }
);

export function apiError(detail) {
  if (detail == null) return "Er ging iets mis. Probeer opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
